export default __webpack_public_path__ + "static/media/bitcoin-whitepaper-satoshi-nakamoto.3b85df6a.pdf";